export default ['Success', 'Info', 'Warning', 'Danger', 'Default'];
